import { render, staticRenderFns } from "./RiskSort.vue?vue&type=template&id=790f985f&scoped=true&"
import script from "./RiskSort.vue?vue&type=script&lang=js&"
export * from "./RiskSort.vue?vue&type=script&lang=js&"
import style0 from "./RiskSort.vue?vue&type=style&index=0&id=790f985f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790f985f",
  null
  
)

export default component.exports